<template>
  <div class="new-application">
    <el-card class="box-card">
      <folded-panel infoName="售前顾问跟进申请单明细">
      <div slot="content">
        <div>
          <dynamic-form
            labelWidth="110px"
            ref="foo"
            :formConfig="formConfig"
            v-model="form"
            :showBtn="false"
            :showSaveBtn="isEdit"
            :disabled="!isEdit"
            @input="handelInput"
          />
        </div>
        <dynamic-form
          labelWidth="110px"
          ref="form"
          :formConfig="formConfigs"
          v-model="form"
          :showBtn="false"
          :showSaveBtn="isEdit"
          :disabled="!isEdit"
          @input="handelInput"
        />
        </div>
        </folded-panel>
      <!-- <folded-panel infoName="历史支持明细">
        <div slot="content">
          <edit-data-table
            :showNumber="editTable.showNumber"
            :head="editTable.bsPerformanceCompositionList"
            :editable="isEdit"
            :config="{ trigger: 'click', mode: 'cell',autoClearActive:false}"
            :showAdd="isEdit"
            :edit-rules="validRules"
            :border="true"
            :data.sync="tableData"
            ref="delRew"
            height=""
          >
            <template #toolbar="scope">
              <span v-if="!isEdit">无</span>
              <el-popover v-if="isEdit" :ref="scope.$index + 'a'" placement="top" width="180">
                <p>确定删除本条数据吗？</p>
                <div style="text-align: right; margin: 0">
                  <el-button size="mini" type="text" @click="$refs[scope.$index + 'a'].doClose()">取消</el-button>
                  <el-button
                    :loading="loading"
                    type="primary"
                    size="mini"
                    @click="subDelete(scope.row.id,scope)">确定
                  </el-button>
                </div>
                <el-button type="text" size="mini" icon="el-icon-delete" slot="reference"></el-button> -->
                <!-- <el-button slot="reference" type="danger" icon="el-icon-delete" size="mini"/> -->
              <!-- </el-popover>
            </template> -->
            <!--基础资料，预算项目-->
            <!-- <template #agoPreSaleIds="{row}">
              <span>{{row.agoPreSaleIds?row.agoPreSaleIds.name:''}}</span>
            </template>
            <template #agoPreSaleIdsEdit="{row}">
              <data-box
                hostUrl="/biz-pre-sale-application/getList"
                :props="{label: 'name',value: 'id'}"
                :extendParms="{billState: 3}"
                v-model="row.agoPreSaleIds"
                :tableColumn="headLevels"
                :multiple="false"
                @confirm="(val)=> confirm(row,val)"
              ></data-box>
            </template>
          </edit-data-table>
        </div>
      </folded-panel> -->
      <div class="button">
        <el-button class="btn-cancel" v-if="isEdit" :loading="loading" @click="save(1)">保存</el-button>
        <el-button class="btn-submit" v-if="isEdit" :loading="loading" @click="submit(2)">提交</el-button>
        <el-button class="btn-cancel" @click="cancel">取消</el-button>
      </div>
       <drag-dialog :show="stepShow" :title="'审批人选择'" :width="'25%'" @close="close">
        <PersonStep :data="personStepData" @submit="submitConfirm" @close="close"></PersonStep>
      </drag-dialog>
    </el-card>
  </div>
</template>

<script>
import "@/components/dynamic-form";
import '@/components/EditDataTable'
import { addForm,idQuery,updatedForm } from "@/api/bill/followupForm";
import { getDocumentCode } from "@/views/utils";
import { parseTime } from "@/utils";
import initDict from "@/mixin/initDict";
import CrudMixin from "@/mixins/CrudMixin";
import FoldedPanel from "@/components/FoldedPanel"
import DragDialog from "@/components/DragDialog"
import { getFlowNode } from "@/api/hrApproval"
import PersonStep from "@/components/PersonStep";

export default {
  name: "AddfollowupForm",
  mixins: [initDict,CrudMixin],
  components: {
    FoldedPanel,DragDialog,PersonStep
    // DataBox
  },
  data() {
    return {
      id: "",
      form: { supportRange: [], productRange: []},
      isEdit: false,
      tableData: [],
      validateRefNames: ['foo','form'],
      editTable: {
          showNumber: true,
          enableEdit: true,
          showAdd: true,
          bsPerformanceCompositionList: [
            {
              label: '历史支持',
              prop: 'agoPreSaleIds',
              editRender: {
                type: 'default',
                name: 'ElInput',
              }
            },
            {
              label: '支持时间',
              prop: 'supportTime',
              editRender: {type: 'date', name: 'ElInput'}
            },
            {
              label: '进展',
              prop: 'progress',
              editRender: {
                type: 'textarea',
                name: 'ElInput',
              }
            }

          ],
        },
         validRules: {
            balance: [
                {pattern: /^\d+\.?(\d{1,2})?$/,message: '小数点后保留两位',trigger: "change"}
              ]
          },
      loading: false,
      headLevels: [
        // { label: "编码", property: "code" },
        { label: "名称", property: "name", query: { type: "input" } },
        { label: "客户名称", property: "shortName" }
      ],
      formConfig: {
        formItemList: [
          {
            type: "input",
            key: "code",
            label: "单据编号",
            value: "",
            span: 8,
            disabled: true,
          },
          {
            type: "input",
            key: "name",
            label: "单据名称",
            value: "",
            span: 8,
            disabled: true,
          },
          {
            label: "客户全称",
            key: "shortNameId",
            type: "databox",
            placeholder: "请选择",
            span: 8,
            props: {
              label: "name",
              value: "id"
            },
            url: "/customer",
            tableColumn: [
              {
                property: "name",
                label: "名称",
                align: "center",
                query: {
                  type: "input"
                }
              }
            ],
            extendParms: { queryFieldItem: "id,number,name" },
            multiple: false,
            rules: {
              required: true,
              message: "不能为空",
              trigger: "change"
            }
          },
          {
            type: "input",
            key: "industryId",
            label: "所属行业/产品",
            placeholder: "请填写",
            value: "",
            span: 8,
            disabled: true
          },
          {
            type: "radio",
            key: "shortRank",
            label: "客户级别",
            disabled: false,
            value: "",
            span: 8,
            border: false,
             options: [
                 {label: "A", value: "A"},
                 {label: "B", value: "B"},
                 {label: "C", value: "C"},
                 {label: "D", value: "D"},
             ]
          },
          {
            label: "预计合同金额",
            key: "totals",
            type: "number",
            placeholder: "请填写",
            span: 8,
            disabled: false,
          },
          {
            label: "申请日期",
            key: "applicationDate",
            type: "date",
            placeholder: "请填写",
            span: 8,
            disabled: false,
            valueFormat: "yyyy-MM-dd"
          },
          {
            type: "date",
            key: "supportTime",
            label: "首次支持时间",
            value: "",
            span: 8,
            valueFormat: "yyyy-MM-dd",
            rules: {
              required: true,
              message: "不能为空",
              trigger: "blur"
            }
          },
          {
            type: "radio",
            key: "time",
            label: "星期",
            disabled: false,
            value: "",
            span: 8,
            border: false,
            options: [
                 {label: "上午", value: "0"},
                 {label: "下午", value: "1"},
                 {label: "全体", value: "2"},
            ],
            rules: {
              required: true,
              message: "不能为空",
              trigger: "blur"
            }
          },
          {
            type: "radio",
            key: "supportSite",
            label: "支持地点",
            disabled: false,
            value: "",
            span: 8,
            border: false,
             options: [
                 {label: "客户处", value: "0"},
                 {label: "本公司处", value: "1"},
             ]
          },
          {
            label: "建议支持人员",
            key: "supportPersonId",
            type: "databox",
            placeholder: "请选择人员",
            span: 8,
            props: {
              label: "name",
              value: ""
            },
            url: "/bs-person/getList",
            tableColumn: [
              {
                property: "name",
                label: "名称",
                align: "center",
                query: {
                  type: "input"
                }
              }
            ],
            extendParms: { queryFieldItem: "id,number,name" },
            multiple: false,
            rules: {
              required: true,
              message: "不能为空",
              trigger: "change"
            }
          },
          {
            type: "checkbox",
            key: "supportRange",
            label: "全程支持范围",
            disabled: false,
            value: [],
            span: 17,
            border: false,
            options: []
          },
          {
            type: "checkbox",
            key: "productRange",
            label: "重点产品",
            disabled: false,
            value: [],
            span: 17,
            border: false,
            options: []
          },
          {
            type: "textarea",
            key: "detailedAddress",
            label: "客户公司具体地址",
            disabled: true,
            span: 20,
            maxlength: 200,
          },
          {
            type: "textarea",
            key: "supportCause",
            label: "申请全程跟进支持原因",
            disabled: false,
            value: "",
            placeholder: "请输入原因",
            span: 20,
            maxlength: 200,
          },
        ]
      },
      formConfigs: {
        formItemList: [
          {
            label: "申请人",
            key: "proposer",
            type: "databox",
            placeholder: "请选择人员",
            span: 8,
            props: {
              label: "name",
              value: "id"
            },
            url: "/bs-person/getList",
            tableColumn: [
              {
                property: "code",
                label: "编码",
                align: "center",
                query: {
                  type: "input"
                }
              },
              {
                property: "name",
                label: "名称",
                align: "center",
                query: {
                  type: "input"
                }
              }
            ],
            extendParms: { queryFieldItem: "id,number,name" },
            multiple: false,
            rules: {
              required: true,
              message: "不能为空",
              trigger: "change"
            }
          },
          {
            type: "input",
            key: "proposerB",
            label: "申请部门",
            disabled: true,
            span: 8,
            maxlength: 200,
          },
          {
            label: "确定支持人员",
            key: "confirmSupportPerson",
            type: "databox",
            placeholder: "请选择人员",
            span: 8,
            props: {
              label: "name",
              value: "id"
            },
            url: "/bs-person/getList",
            tableColumn: [
              {
                property: "code",
                label: "编码",
                align: "center",
                query: {
                  type: "input"
                }
              },
              {
                property: "name",
                label: "名称",
                align: "center",
                query: {
                  type: "input"
                }
              }
            ],
            extendParms: { queryFieldItem: "id,number,name" },
            multiple: false,
            rules: {
              required: true,
              message: "不能为空",
              trigger: "change"
            }
          },
          {
            type: "textarea",
            key: "shortAboutUs",
            label: "客户公司情况简介",
            disabled: false,
            span: 20,
            maxlength: 200,
            rules: {
              required: true,
              message: "不能为空",
              trigger: "blur"
            }
          },
          {
            type: "textarea",
            key: "shortSwtoAnalyze",
            label: "客户需求分析与SWTO分析",
            disabled: false,
            span: 20,
            maxlength: 200,
            rules: {
              required: true,
              message: "不能为空",
              trigger: "blur"
            }
          },
          {
            type: "textarea",
            key: "keyPoint",
            label: "重点注意事项",
            disabled: false,
            span: 20,
            maxlength: 200,
            rules: {
              required: true,
              message: "不能为空",
              trigger: "blur"
            }
          },
          {
            type: "textarea",
            key: "rival",
            label: "竞争对手说明情况",
            disabled: false,
            span: 20,
            maxlength: 200,
            rules: {
              required: true,
              message: "不能为空",
              trigger: "blur"
            }
          },
        ]
      },
      receipTypes: [],
       personStepData: [],
      form2: {}, // hr审批
      assignData: {}, // hr审批人员信息
      stepShow: false,
    };
  },
  created() {
    this.id = this.$route.params.id;
    this.isEdit = this.$route.params.isEdit !== undefined ? Boolean(Number(this.$route.params.isEdit)) : true;
    if (this.id) {
      idQuery(this.id).then(res => {
        const formObj = res.data.bizPreSaleApplication
        if (!formObj.productRangeList) {
          formObj.productRangeList = []
        }
        if (!formObj.supportRangeList) {
          formObj.supportRangeList = []
        }
        this.form = formObj
        this.tableData = res.data.bizPreSaleRecordList
        this.tableData.forEach(ele => { ele.agoPreSaleIds = { name: ele.preSaleName,id: ele.agoPreSaleId } })
        this.form.supportRange = formObj.supportRangeList
        this.form.productRange = formObj.productRangeList
        this.form.proposer = { name: formObj.proposerPerson.name,id: formObj.proposerPerson.id}
        this.form.proposerB = formObj.proposerPerson.departmentName
        this.form.supportPersonId = { name: formObj.supportPersonName,id: formObj.supportPersonId}
        this.form.confirmSupportPerson = { name: formObj.confirmSupportPersonName,id: formObj.confirmSupportPerson}
        this.form.shortNameId = formObj.bsCustomer
        this.form.detailedAddress = formObj.bsCustomer.detailedAddress
        this.form.industryId = formObj.bsCustomer.industry.name
        this.form.supportRange.length > 0 ? this.handelInput(this.form,"supportRange") : ''
        this.form.productRange.length > 0 ? this.handelInput(this.form,"productRange") : ''
      })
    } else {
      this.form.code = getDocumentCode("SQGW");
    }
    this.getDict("supportRange").then(res => {
        this.formConfig.formItemList[this.formConfig.formItemList.findIndex(ele => ele.key === 'supportRange')].options = res.data;
    });
    this.getDict("productRange").then(res => {
        this.formConfig.formItemList[this.formConfig.formItemList.findIndex(ele => ele.key === 'productRange')].options = res.data;
    });
  },
  watch: {
  },
  mounted() {
    if (this.form.supportTime) {
          this.$set(this.formConfig.formItemList[this.formConfig.formItemList.findIndex(ele => ele.key === "time")],"label",'星期' + parseTime(new Date(this.form.supportTime),'{a}'))
        } else {
          this.$set(this.formConfig.formItemList[this.formConfig.formItemList.findIndex(ele => ele.key === "time")],"label",'星期' + parseTime(new Date(),'{a}'))
        }
  },
  methods: {
    /**
     * 表单值改变
     */
    handelInput(val,key) {
      const supportRangeIndex = this.formConfig.formItemList.findIndex(ele => ele.key === "supportRange")
      const explainIndex = this.formConfig.formItemList.findIndex(ele => ele.key === "supportRangeExplain")
      const supportRangeObj = {
        type: "input",
        key: "supportRangeExplain",
        label: "其他范围说明",
        value: "",
        span: 16,
        rules: {
          required: true,
          message: "不能为空",
          trigger: "blur"
        }
      }

      const productRangeIndex = this.formConfig.formItemList.findIndex(ele => ele.key === "productRange")
      const preIndex = this.formConfig.formItemList.findIndex(ele => ele.key === "productRangeExplain")
      const productRangeObj = {
        type: "input",
        key: "productRangeExplain",
        label: "其他产品说明",
        value: "",
        span: 16,
        rules: {
          required: true,
          message: "不能为空",
          trigger: "blur"
        }
      }
      switch (key) {
        case "proposer": // 申请人
          if (val[key]) {
            this.form.proposerB = val[key].departmentName
          } else {
            this.form.proposerB = ""
          }
          break;
        case "supportRange": // 全程支持范围
          if (val[key].includes("1") && explainIndex === -1) {
            this.formConfig.formItemList.splice(supportRangeIndex + 1,0,supportRangeObj)
          } else if (!val[key].includes("1") && explainIndex !== -1) {
            this.form.supportRangeExplain = ""
            this.formConfig.formItemList.splice(explainIndex,1)
          }
          break;
        case "productRange": // 重点产品
          if (val[key].includes("1") && preIndex === -1) {
            this.formConfig.formItemList.splice(productRangeIndex + 1,0,productRangeObj)
          } else if (!val[key].includes("1") && preIndex !== -1) {
            this.form.productRangeExplain = ""
            this.formConfig.formItemList.splice(preIndex,1)
          }
          break;
        case "shortNameId":
          if (val[key]) {
            this.form.name = val[key].name + "/" + parseTime(new Date(),'{y}-{m}-{d}') + "/" + "售前"
            this.form.detailedAddress = val[key].detailedAddress
            this.form.industryId = val[key].industry.name
          } else {
            this.form.name = ""
            this.form.detailedAddress = ""
            this.form.industryId = ""
          }
          break;
        case "supportTime":
          if (val[key]) {
            this.$set(this.formConfig.formItemList[this.formConfig.formItemList.findIndex(ele => ele.key === "time")],"label",'星期' + parseTime(new Date(val[key]),'{a}'))
          } else {
            this.$set(this.formConfig.formItemList[this.formConfig.formItemList.findIndex(ele => ele.key === "time")],"label",'星期' + parseTime(new Date(),'{a}'))
          }
          break;
        default:
          break;
      }
    },
    /**
     * 表格弹框确认
     */
    confirm(row,val) {
      row.agoPreSaleId = val.id;
      row.supportTime = val.supportTime
    },
    subDelete(id, scope) {
        this.tableData.splice(scope.$index, 1);
        this.$refs[scope.$index + 'a'].doClose()
    },
      close() {
        this.stepShow = false;
    },
    submitConfirm(val) {
      // this.getFormData(2,val)
      this.loading = true
       const obj = this.getFormData(2)
      const obj2 = {}
      val.forEach(item => {
        let userList = "";
        item.assignData.forEach(ite => {
          userList = userList + (userList === "" ? ite.id : "," + ite.id);
        });
        obj2[item.key] = userList;
      });
      obj.assignData = JSON.stringify(obj2)
      obj.from = "followupForm"
      // console.log('rjuq..',obj)
      this.pull(obj)
    },
    // 提交
    submit(status) {
      this.loading =  true;
      this._validateForm(this.validateRefNames).then(res => {
        // this.pull(this.getFormData(status))
          getFlowNode({ from: "followupForm", id: this.form.id }).then(res => {
              this.loading = false;
          this.personStepData = [];
          if (res.code === 200) {
              this.stepShow = true;
              this.personStepData = res.data;
          }
        });
      }).catch(e => { this.loading = false })
    },
    // 保存
    save(status) {
      this.loading = true
      this.pull(this.getFormData(status));
    },
    // 组装表单数据
    getFormData(status) {
       console.log(this.form);
      const obj = {...this.form}
      obj.billState = status;
      obj.proposer = this.form.proposer.id // 申请人
      obj.confirmSupportPerson = this.form.confirmSupportPerson.id // 确定支持人员
      obj.supportPersonId = this.form.supportPersonId.id // 建议支持人员
      obj.supportRangeList = this.form.supportRange
      obj.supportRange = ""
      obj.productRangeList = this.form.productRange
      obj.productRange = ""
      obj.shortNameId = this.form.shortNameId.id
      return { bizPreSaleApplication: obj,bizPreSaleRecordList: this.tableData}
    },
    cancel() {
      this.$router.go(-1);
    },
    back() {
      this.$router.go(-1);
    },
    pull(obj) {
      if (this.id) {
        updatedForm(obj).then(res => {
          this.loading =  false
          if (res.code === 200) {
            this.$notify({
              title: "操作成功！",
              type: "success",
              duration: 2500
            });
            this.cancel();
          }
        });
      } else {
        addForm(obj).then(res => {
          this.loading = false
          if (res.code === 200) {
            this.$notify({
              title: "操作成功！",
              type: "success",
              duration: 2500
            });
            this.cancel();
          }
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.el-icon-back {
  padding-bottom: 10px;
}
.button {
        padding-top: 20px;
        text-align: right;

        .btn-submit {
          width: 80px;
          height: 38px;
          background: #1369a8;
          color: white;
        }

        .btn-cancel {
          width: 80px;
          height: 38px;
          background: #fff;
        }
      }
</style>
